/** Order list “code” filters (Korona workflow stages) — query suffixes for unfinished_orders. */
export const Status_Filters = {
  SAVED_CART: 'Saved Cart',
  PAID: 'Paid',
  CHECKEDOUT: 'Checkout Out',
  PUSHED_TO_POS_BACKEND: 'Pushed to POS Backend',
  READY_TO_FULFILL: 'Ready For Fulfill',
  PICKING: 'Picking',
  FINISHED_PICKING: 'Finished Picking',
  PACKED: 'Packed',
  READY_TO_PICKUP: 'Ready to Pickup',
  PICKED_UP: 'Picked up',
  OUT_FOR_DELIVERY: 'Out for Delivery',
  DELIVERED: 'Delivered',
} as const;

export interface BaseFilter {
  id: number;
  name: string;
  displayText: string;
  active: boolean;
  constraint: string;
  isSelected: boolean;
}

export const CodeFilters: BaseFilter[] = [
  {
    id: 1,
    name: Status_Filters.READY_TO_FULFILL,
    displayText: 'Ready to Fulfill',
    constraint: '&ready_to_fulfill=true',
    active: false,
    isSelected: false,
  },
  {
    id: 2,
    name: Status_Filters.PICKING,
    displayText: 'Picking',
    constraint: '&picking=true',
    active: false,
    isSelected: false,
  },
  {
    id: 3,
    name: Status_Filters.FINISHED_PICKING,
    displayText: 'Finished Picking',
    constraint: '&finished_picking=true',
    active: false,
    isSelected: false,
  },
  {
    id: 4,
    name: Status_Filters.PACKED,
    displayText: 'Packed',
    constraint: '&packed=true',
    active: false,
    isSelected: false,
  },
  {
    id: 5,
    name: Status_Filters.READY_TO_PICKUP,
    displayText: 'Ready to Pickup',
    constraint: '&ready_to_pickup=true',
    active: false,
    isSelected: false,
  },
  {
    id: 6,
    name: Status_Filters.PICKED_UP,
    displayText: 'Picked up',
    constraint: '&picked_up=true',
    active: false,
    isSelected: false,
  },
  {
    id: 7,
    name: Status_Filters.OUT_FOR_DELIVERY,
    displayText: 'Out for Delivery',
    constraint: '&out_for_delivery=true',
    active: false,
    isSelected: false,
  },
  {
    id: 8,
    name: Status_Filters.DELIVERED,
    displayText: 'Delivered',
    constraint: '&delivered=true',
    active: false,
    isSelected: false,
  },
];
